import * as React from 'react'
import clsx from 'clsx'
import Caption from 'LuxKit/Typography/Caption'
import { _LabelElement } from './_LabelElement'

type InheritedCaptionProps = Pick<React.ComponentProps<typeof Caption>, 'format'>
type Kind = 'primary' | 'secondary' | 'tertiary' | 'plain'
type Variant = 'dark'
  | 'ghost'
  | 'grey'
  | 'highlight'
  | 'highlight-primary-dark'
  | 'highlight-secondary'
  | 'success'
  | 'urgency'
  | 'fast'
  | 'warning'
  | 'critical'
  | 'exclusive'
  | 'velocity'
  | 'ultra'
  | 'lux-plus'
  | 'maldives-charter'
  | 'kids-free'
  | 'perfect-for-groups'
  | 'great-for-families'
  | 'only-in-australia'
  | 'loyalty-bronze-dark'
  | 'loyalty-silver-dark'
  | 'loyalty-gold-dark'
  | 'loyalty-platinum-dark'
  | 'loyalty-infinite-dark'

interface Props extends React.HTMLAttributes<HTMLSpanElement>, InheritedCaptionProps {
  kind: Kind
  variant: Variant
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
}

/**
 * This is a base 'abstract' label that is used by all the *implementation labels*
 * This should never be used directly. Talk to your designer to discover the correct
 * label type to use in the event you are unsure.
 */
function Label(props: Props) {
  const {
    kind,
    variant,
    startIcon,
    endIcon,
    children,
    className,
    format,
    ...rest
  } = props

  return <_LabelElement
    {...rest}
    className={clsx(
      className,
      `kind-${kind}`,
      `variant-${variant}`,
    )}
  >
    {startIcon}
    <Caption variant="medium" weight="bold" format={format}>{children}</Caption>
    {endIcon}
  </_LabelElement>
}

Label.displayName = 'Label'

export default Label
